<template>
  <div>
    <!-- 自定义导航 -->
    <Nav></Nav>
    <!-- 自定义导航-->
    <!-- 首页内容-->
    <div class="content-wrap">
      <!-- 联系方式-->
      <div class="top-wrap">
        <div class="title">2020年最火爆的微商项目</div>
        <div class="sub-title">全国电影院8.5折，扫码加入</div>
        <div class="contact">
          <div class="margin-r-35">
            <div class="img-box"><img src="@/assets/img/h5/applet.jpg" alt=""></div>
            <div class="img-tip">购票体验小程序</div>
          </div>
          <div>
            <div class="img-box"><img class="qrcode" src="@/assets/img/h5/qrcode.jpg" alt=""></div>
            <div class="img-tip">联系客服微信</div>
          </div>
        </div>
        <div class="btn-register" @click="toLogin">入驻/注册</div>
      </div>
      <!-- 联系方式-->
      <!-- 接入流程 -->
      <div class="advantage-wrap padding-15">
        <div class="advantage-title">接入流程</div>
        <div class="poster-div">
          <span class="font-10">简单4步 轻松推广获取佣金</span>
        </div>
        <div class="step-flex">
          <div class="step-row">
            <img src="@/assets/img/h5/official/home_process_login_1.png" />
            <div class="step-name"><div><span class="font-11">1</span></div>注册账号</div>
          </div>
          <div class="step-row">
            <img src="@/assets/img/h5/official/home_process_buy_2.png" />
            <div class="step-name"><div><span class="font-11">2</span></div>购买套餐</div>
          </div>
          <div class="step-row">
            <img src="@/assets/img/h5/official/home_process_accredit_3.png" />
            <div class="step-name"><div><span class="font-11">3</span></div>授权公众号</div>
          </div>
          <div class="step-row">
            <img src="@/assets/img/h5/official/home_process_tuiguang_4.png" />
            <div class="step-name"><div><span class="font-11">4</span></div>推广赚钱</div>
          </div>
        </div>

      </div>
      <!-- 接入流程-->
      <!-- 我们的优势 -->
      <div class="promotion-wrap padding-15">
        <div class="promotion-title">我们的优势</div>
        <div>
          <div class="pro-div">
            <div class="pro-bg-box">
              <img src="@/assets/img/h5/official/home_advantage_bg_1.png"/>
              <div>平台优势</div>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">全国影院覆盖，在线选座，在线购票；</div>
              <div class="pro-des-div">系统全自动出票，售后少，回购高，省时省力；</div>
              <div class="pro-des-div">多种出票模式，满足不同用户需求</div>
              <div class="pro-des-div">用户购票价格对标猫眼淘票票3~9折；</div>
              <div class="pro-des-div">总利润不低于售价的8%（秒出票除外），利润率可观；</div>
              <div class="pro-des-div">对接渠道多样化, 社群, 公众号, 小程序, app皆可对接；</div>
              <div class="pro-des-div">无需服务器，域名，对接流程简捷，5分钟上线</div>
              <div class="pro-des-div">多对一专属服务</div>
              <div class="pro-des-div">持续更新新功能附加</div>
              <div class="pro-des-div">佣金提现快，无门槛</div>
            </div>
          </div>
          <div class="pro-div">
            <div class="pro-bg-box">
              <img src="@/assets/img/h5/official/home_advantage_bg_2.png"/>
              <div>项目优势</div>
            </div>
            <div class="pro-des-box">
              <div class="pro-des-div">易推广裂变，用户粘性高</div>
              <div class="pro-des-div">利润空间大，可多重变现</div>
              <div class="pro-des-div">市场空间大，竞争强度低</div>
              <div class="pro-des-title-div">支付对接的场景</div>
              <div class="pro-des-div">微信公众号</div>
              <div class="pro-des-div">小程序</div>
              <div class="pro-des-div">社群</div>
              <div class="pro-des-div">APP</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 我们的优势-->
      <!-- 版本功能对比-->
      <div class="joinus-wrap padding-15">
        <div class="joinus-title">版本功能对比</div>
        <div class="version-wrap">
          <div class="version-name">
            <div class="version-title version-basic" :class="{'active': curVersion=='basic'}" @click="changeCurVersion('basic')">基础版<span v-show="curVersion=='basic'">（99-699元/年）</span></div>
            <div class="version-title version-official" :class="{'active': curVersion=='official'}" @click="changeCurVersion('official')">分销版<span v-show="curVersion=='official'">（2699元/年）</span></div>
          </div>
          <div class="version-server">
            <div class="server-range-title">服务范围</div>
            <div class="server-range-content">
              <div class="left-box">
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>获取全国影院信息</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>获取即将上映影片信息</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>特惠购票功能</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>无限制推送商品消息</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>订单报表</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>会员系统</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>用户裂变模块</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>自定义消息回复</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>所有辅助软件</div>
                </div>
              </div>
              <div class="right-box">
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>获取最新影片信息</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>秒出票功能</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>竞价购票功能</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>绑定小程序</div>
                </div>
                <div class="server-row">
                  <img src="@/assets/img/h5/official/home_icon_tick.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>推广素材库</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>粉丝维度模块</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>自定义域名</div>
                </div>
                <div class="server-row" :class="{'server-no-row':curVersion=='basic'}">
                  <img src="@/assets/img/h5/official/home_icon_cross.png" v-show="curVersion=='basic'"/>
                  <img src="@/assets/img/h5/official/home_icon_tick_red.png" v-show="curVersion=='official'"/>
                  <div>自定义邀请海报</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 版本功能对比-->
      <!-- 支持对接的场景-->
      <div class="scene-wrap">
        <div class="scene-box">
          <div class="scene-title">支持对接的场景</div>
          <div class="scene-content">微信公众号、小程序、社群、APP</div>
          <div class="function-info">功能说明</div>
          <div class="function-box">
            <div class="function-row">在线购票</div>
            <div class="function-row">快速变形</div>
            <div class="function-row">收益可观</div>
            <div class="function-row">加盟简单</div>
          </div>
        </div>
        <img class="scene-img" src="@/assets/img/h5/official/home_scenario_bg.png">
      </div>
      <!-- 支持对接的场景-->
      <!-- 底部-->
      <div class="footer-wrap padding-15">
        <div class="footer-box">
          <div class="footer-tag">
            <span>关于我们</span>
            <span>法律声明</span>
            <span>廉政举报</span>
            <span>友情链接</span>
          </div>
          <div class="copyright"><span class="font-11"> © 2020-2030 shoutu.com 版权所有 ICP：闽DSS2-487545</span></div>
        </div>
      </div>
      <!-- 底部 -->
      <!-- 返回顶部 -->
      <div class="go-top" :class="{'hidden': !gotop}" @click="goTop">
        <img src="@/assets/img/h5/official/home_btn_top.png"/>
      </div>
      <!-- 返回顶部 -->
    </div>
  </div>
</template>

<script>
  import Nav from '@/components/h5/Nav.vue'
  import { getToken, getHasPackage, getUserUUID, setSnapshotId, setHasPackage, setIsAuthOfficial } from '@/utils/auth'
  import official from '@/javaApi/official'
  const officialModel = new official()
  export default {
    name: 'Home',
    components: {
      Nav
    },
    data () {
      return {
        curVersion: 'basic',
        gotop: false,
      }
    },
    created() {
      if(this.$route.query.invite_code){
        let inviteCode = this.$route.query.invite_code
        localStorage.setItem('inviteCode',inviteCode)
      }
    },
    mounted() {
      // 此处true需要加上，不加滚动事件可能绑定不成功
      window.addEventListener("scroll", this.handleScroll, true);
    },
    methods:{
      // 切换版本
      changeCurVersion(cur){
        this.curVersion = cur
      },
      toLogin(){
        var that = this
        var token = getToken()
        if (token === undefined || token === '') {
          that.$store.dispatch('nav/changeActiveIndex', 0)
          that.$store.dispatch('nav/changeIsGoOfficial', 1)
          that.$router.push('/h5/login')
        }else{
          that.hasPackage = getHasPackage() === 'true' ? true : false
          if(that.hasPackage === false){
            var that = this;
            //未开通套餐时，点击任何菜单都是跳转到激活续费页面
            // 弹窗提示
            that.$store.dispatch('official/changeIsShowSlide', true)
            // 增加判断，如果是有其他公众号的情况下，可直接进入其他默认公众号
            officialModel.publicLogin({openUserUuid: getUserUUID()}).then((response) => {
              var res = response.data
              if(res.code == 200 && res.data.binds.length > 0) {
                let defaultOfficial = res.data.binds[0];
                setSnapshotId(defaultOfficial.snapshotId)
                setHasPackage(true)
                if(defaultOfficial.platformUuid !== '' && defaultOfficial.platformName !== ''){
                  setIsAuthOfficial(true)
                }else{
                  setIsAuthOfficial(false)
                }
                this.$store.dispatch('h_nav/changeOfficialActiveIndex', '0')
                // 快照id
                this.$router.push({
                  path: '/h5/official/statistics',
                  query: { platformUuid: defaultOfficial.platformUuid,snapshotId:defaultOfficial.snapshotId }
                })
                return false;
              } else {
                var toPath = '/h5/official/dialog';
                that.$router.push(toPath);
              }
            })

            // window.open('#/pc/official/dialog','_brank')
            // let targetDiv = document.getElementById('open-new')
            // targetDiv.getElementsByTagName('a')[0].click()
          }else{
            that.$store.dispatch('official/changeIsShowSlide', true)
            // let targetDiv = document.getElementById('to-stat')
            // targetDiv.getElementsByTagName('a')[0].click()
            var toPath = '/h5/official/statistics';
            that.$router.push(toPath);
          }
        }
      },
      // 滚动时，显示返回顶部图标
      handleScroll() {
        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
        scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
      },
      // 返回顶部
      goTop() {
        let top = document.documentElement.scrollTop || document.body.scrollTop;
        // 实现滚动效果
        const timeTop = setInterval(() => {
          document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      }
    }
  }
</script>

<style lang="less" scoped>
  .content-wrap{
    position: absolute;
    width: 100%;
    .top-wrap{
      min-height: 351px;
      background-image: url(../../../../assets/img/h5/official/home_poster_bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      width: 100%;
      color: #FFFFFF;
      text-align: center;
      padding: 40px 0 23px;
      .title{
        font-size: 24px;
        line-height: 33px;
        font-family: Alibaba-PuHuiTi-M;
      }
      .sub-title{
         font-size: 16px;
         line-height: 22px;
         padding-top: 6px;
         padding-bottom: 20px;
         font-family: Alibaba-PuHuiTi-R;
      }
      .contact{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .img-box{
          width: 110px;
          height: 110px;
          background: #FFFFFF;
          img{
            width: 97px;
            height: 97px;
            margin-top: 7px;
          }
          .qrcode{
            width: 110px;
            height: 110px;
            margin-top: 0px;
          }
        }
        .img-tip{
          padding-top: 11px;
          font-size: 12px;
          font-family: Alibaba-PuHuiTi-R;
        }
      }
      .btn-register{
        margin: 30px auto 0;
        width: 130px;
        height: 40px;
        padding: 9px 29px;
        background: #FF8622;
        border-radius: 4px;
        font-family: Alibaba-PuHuiTi-R;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
    .advantage-wrap{
      background: #FFFFFF;
      .advantage-title{
        font-size: 24px;
        color: #222222;
        letter-spacing: 0;
        padding-top: 15px;
        font-family: Alibaba-PuHuiTi-M;
        line-height: 33px;
      }
      .poster-div{
        margin-top: 4px;
        font-family: Alibaba-PuHuiTi-R;
        color: #666666;
        line-height: 16px;
      }
      .step-flex{
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 20px 0 5px;
        .step-row{
          width: 50%;
          text-align: center;
          padding: 10px 0;
          img{
            width: 70px;
          }
          .step-name{
            margin-top: 12px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #333333;
            display: flex;
            justify-content: center;
            line-height: 20px;
            div{
              background: #FFFFFF;
              border: 1px solid #999999;
              width: 16px;
              height: 16px;
              line-height: 16px;
              border-radius: 16px;
              margin-top: 2px;
              margin-right: 8px;
              span{
                display: flex;
                justify-content:center;
                margin-top: -2px;
                font-family: PingFangSC-Regular;
                color: #333333;
              }
            }
          }
        }
      }
    }
    .promotion-wrap{
      background:  #F3F3F3;
      font-family: Alibaba-PuHuiTi-R;
      .promotion-title{
        font-size: 24px;
        color: #222222;
        letter-spacing: 0;
        padding: 25px 0 20px;
        font-family: Alibaba-PuHuiTi-M;
      }
      .pro-div{
        background: #FFFFFF;
        margin-bottom: 15px;
        .pro-bg-box{
          position: relative;
          img{
            width: 100%;
          }
          div{
            font-family: Alibaba-PuHuiTi-M;
            font-size: 18px;
            color: #FFFFFF;
            text-align: justify;
            position: absolute;
            left: 50%;
            top: 42.69%;
            transform: translateX(-50%);
            -ms-transform: translateX(-50%);	/* IE 9 */
            -moz-transform: translateX(-50%); 	/* Firefox */
            -webkit-transform: translateX(-50%); /* Safari 和 Chrome */
            -o-transform: translateX(-50%); 	/* Opera */
          }
        }
        .pro-des-box{
          font-family: Alibaba-PuHuiTi-R;
          font-size: 12px;
          color: #666666;
          text-align: justify;
          padding: 15px;
          line-height: 17px;
          .pro-des-div{
            margin-bottom: 8px;
            padding-left: 20px;
            position: relative;
          }
          .pro-des-div:last-child{
            margin-bottom: 5px;
          }
          .pro-des-div::after{
            content: '';
            width: 6px;
            height: 6px;
            background: #FF9734;
            position: absolute;
            left: 7px;
            top: 7px;
            transform:rotate(45deg);
            -ms-transform:rotate(45deg); 	/* IE 9 */
            -moz-transform:rotate(45deg); 	/* Firefox */
            -webkit-transform:rotate(45deg); /* Safari 和 Chrome */
            -o-transform:rotate(45deg); 	/* Opera */
          }
          .pro-des-div span{
            color: #FF4F76;
          }
          .pro-des-title-div{
            font-family: Alibaba-PuHuiTi-R;
            font-size: 16px;
            color: #222222;
            text-align: justify;
            margin:24px 0 12px;
          }
        }

      }
    }
    .joinus-wrap{
      background: #FFFFFF;
      font-family: Alibaba-PuHuiTi-R;
      .joinus-title{
        font-size: 24px;
        color: #222222;
        letter-spacing: 0;
        padding: 25px 0 20px 0;
        font-family: Alibaba-PuHuiTi-M;
      }
      .version-wrap{
        .version-name{
          display: flex;
          align-items: flex-end;
          .version-title{
            border-radius: 4px 4px 0 0;
            font-family: Alibaba-PuHuiTi-R;
            color: #FFFFFF;
            text-align: justify;
            font-size: 14px;
            padding: 7px 20px;
            height: 32px;
            cursor: pointer;
            span{
              font-family: Alibaba-PuHuiTi-M;
              font-size: 14px;
              color: #FFFFFF;
              text-align: justify;
              line-height: 19px;
            }
          }
          .active{
            font-size: 18px;
            padding: 10px 20px;
            height: 44px;
          }
          .version-basic{
            background: #3D9EFC;
            margin-right: 8px;
            margin-left: 20px;
          }
          .version-official{
            background: #FF4F76;
          }
        }
        .version-server{
          background: #FFFFFF;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,0.10);
          .server-range-title{
            padding-top: 25px;
            padding-bottom: 32px;
            text-align: center;
            font-family: Alibaba-PuHuiTi-R;
            font-size: 18px;
            color: #333333;
          }
        }
        .server-range-content{
          display: flex;
          padding: 0 12px;

          .server-row{
            margin-bottom: 24px;
            font-family: Alibaba-PuHuiTi-R;
            font-size: 12px;
            color: #333333;
            text-align: justify;
            display: flex;
            white-space: nowrap;
            img{
              width: 22px;
              margin-right: 8px;
            }
          }
          .server-no-row{
            color: #C1C1C1;
          }
        }
      }
    }
    .scene-wrap{
      background: #F5F5F5;
      padding: 34px 0 25px;
      overflow: hidden;
      .scene-box{
        margin-left: 15px;
        .scene-title{
          font-family: Alibaba-PuHuiTi-M;
          font-size: 24px;
          color: #222222;
          text-align: justify;
        }
        .scene-content{
          font-family: Alibaba-PuHuiTi-R;
          font-size: 12px;
          color: #333333;
          text-align: justify;
          margin: 8px 0 15px;
        }
        .function-info{
          font-family: Alibaba-PuHuiTi-R;
          font-size: 14px;
          color: #191919;
          text-align: justify;
          margin-bottom: 8px;
        }
        .function-box{
          display: flex;
          .function-row{
            font-family: Alibaba-PuHuiTi-R;
            font-size: 12px;
            color: #666666;
            text-align: justify;
            margin-right: 8px;
          }
        }
      }
      .scene-img{
        width: 85.2%;
        float: right;
      }
    }
    .footer-wrap{
      background: #333333;
      font-family: "microsoft yahei";
      .footer-box{
        padding: 35px 8px;
        .footer-tag{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          color: #FFFFFF;
        }
        .copyright {
          padding-top: 20px;
          color: #999999;
          text-align: center;
        }
      }
    }
    .go-top{
      position: fixed;
      bottom: 47px;
      right: 12px;
      cursor: pointer;
      img{
        width: 40px;
      }
    }
  }
  .hidden{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/official/home/Index.vue